import React, { useState, useEffect, useLayoutEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useSelector } from "react-redux";
import _ from "lodash";
import { monthNames } from "@components/Common/Constant";

/**
 * BarGraph Component
 * Displays a bar chart showing planned vs completed monthly tour planning data
 * Refactored with Tailwind CSS and improved data handling
 * 
 * @component
 */
const BarGraph = () => {
  const [plannedData, setPlannedData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [labels, setLabels] = useState([]);

  useLayoutEffect(() => {
    Chart.register(ChartDataLabels);
    Chart.register(...registerables);
  }, []);

  // Get past 3 months labels
  useEffect(() => {
    const monthLabels = [];
    for (let i = 0; i < 3; i++) {
      const current = new Date();
      monthLabels.unshift(monthNames[current.getMonth() - i]);
    }
    setLabels(monthLabels);
  }, []);

  const graphData = useSelector((state) => state?.barGraph?.graph);

  // Process graph data for planned and completed values
  useEffect(() => {
    if (!graphData) return;

    const planned = [];
    const completed = [];

    Object.keys(graphData).forEach((month) => {
      const months = graphData[month];

      if (_.isEmpty(months)) {
        planned.push(0);
        completed.push(0);
        return;
      }

      let plannedCount = 0;
      let completedCount = 0;

      months.forEach((item) => {
        if (item.Visit_Status_es__c === "Not Visited") {
          plannedCount += item.expr0;
        } else if (item.Visit_Status_es__c === "Visited") {
          completedCount += item.expr0;
        }
      });

      planned.push(plannedCount);
      completed.push(completedCount);
    });

    setPlannedData(planned.reverse());
    setCompletedData(completed.reverse());
  }, [graphData]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Planned",
        data: plannedData,
        backgroundColor: "#FFA600",
        categoryPercentage: 0.6,
      },
      {
        label: "Completed",
        data: completedData,
        backgroundColor: "#2CC26A",
        categoryPercentage: 0.6,
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        anchor: "start",
        align: "top",
        padding: 0.5,
        color: (context) => {
          return context?.dataset?.label === "Completed" ? "#000000" : "#000000";
        },
        font: {
          weight: 600,
          size: 7.9,
        },
      },
    },
    scales: {
      y: {
        display: false,
      },
      x: {
        ticks: {
          display: true,
          color: (context) => {
            return context?.index === 2 ? "green" : "#000000";
          },
          font: {
            size: 14,
            weight: 500,
          },
        },
        grid: {
          display: false,
          borderColor: "#FFFFFF",
        },
      },
    },
  };

  if (!graphData) {
    return null;
  }

  return (
    <div className="w-full h-[90px]">
      <Bar data={chartData} options={chartOptions} height={90} width={130} />
    </div>
  );
};

export default BarGraph;
